import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarEmpleados } from '../../actions/empleados';
import { buscarSucursales } from '../../actions/sucursales';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import EliminarEmpleado from './EliminarEmpleado';
import FiltrosEmpleado from './FiltrosEmpleado';

const tiposEmpleado = [
    { value: 0, label: 'Cajero' },
    { value: 1, label: 'Bateador' },
    { value: 2, label: 'Promotor' },
    { value: 3, label: 'Freidor' },
    { value: 4, label: 'Vendedor ambulante' },
    { value: 5, label: 'Administrador' }
];

const filtrosVacios = { nombre: '', tipo: null, sucursales: [] };

const Empleados = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.empleados);
    const { usuario } = useSelector(state => state.auth);

    const [empleadoEliminar, setEmpleadoEliminar] = useState(null);
    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarSucursales());
        dispatch(editarBreadcrumb([
            { nombre: 'Empleados', path: '/empleados', activo: true }
        ]));
        dispatch(buscarEmpleados(filtrosVacios));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarEmpleados(nuevosFiltros));
    };

    const handleEliminar = (empleado) => {
        setEmpleadoEliminar(empleado);
    };

    const handleCerrarEliminar = () => {
        setEmpleadoEliminar(null);
    };

    const filtrosActivos = [filtros.nombre, filtros.tipo !== null, filtros.sucursales.length > 0].filter(Boolean).length;

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Apellido paterno',
            sortable: true,
            selector: row => row.apellido_paterno || '-',
            grow: 1.5
        },
        {
            name: 'Apellido materno',
            sortable: true,
            selector: row => row.apellido_materno || '-',
            grow: 1.5
        },
        {
            name: 'Tipo',
            sortable: true,
            selector: row => tiposEmpleado.find(t => t.value === row.tipo)?.label || '-'
        },
        {
            name: 'Sucursales',
            sortable: true,
            selector: row => (row.sucursales || []).map(s => s.nombre || s).filter(Boolean).join(', ') || '-',
            grow: 2
        },
        {
            name: 'Teléfono',
            sortable: true,
            selector: row => row.telefono || '-'
        },
        {
            name: '',
            cell: row => (
                <div>
                    {usuario?.permisos?.empleados?.ver && (
                        <Link className="btn btn-sm btn-info me-1" title="Ver perfil" to={`/empleados/perfil/${row._id}`}>
                            <i className="fas fa-eye"></i>
                        </Link>
                    )}
                    {usuario?.permisos?.empleados?.editar && (
                        <button
                            className="btn btn-sm btn-warning me-1"
                            title="Editar"
                            onClick={() => navigate(`/empleados/editar/${row._id}`)}
                        >
                            <i className="fas fa-edit"></i>
                        </button>
                    )}
                    {usuario?.permisos?.empleados?.eliminar && (
                        <button
                            className="btn btn-sm btn-danger"
                            title="Eliminar"
                            onClick={() => handleEliminar(row)}
                        >
                            <i className="fas fa-trash"></i>
                        </button>
                    )}
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Empleados</h4>
                <div className="d-flex gap-3">
                    <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                        <i className="fas fa-filter me-1"></i> Filtros
                        {filtrosActivos > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                                {filtrosActivos}
                            </span>
                        )}
                    </button>
                    {usuario?.permisos?.empleados?.agregar && (
                        <button className="btn btn-primary" onClick={() => navigate('/empleados/nuevo')}>
                            <i className="fas fa-plus me-1"></i> Nuevo empleado
                        </button>
                    )}
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent="No hay empleados registrados"
                />
            </div>

            <FiltrosEmpleado
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />

            <EliminarEmpleado
                empleado={empleadoEliminar}
                handleCerrar={handleCerrarEliminar}
            />
        </div>
    );
};

export default Empleados;
